import {
    GET_USERS_QUANTITY_REQUEST,
    GET_USERS_QUANTITY_SUCCESS,
    GET_USERS_QUANTITY_FAILURE,
} from '../constants/get_users_quantity.constants';

const initialState = {};

export const User_group_quantity = (state = initialState, action) => {
    switch (action.type) {
    case GET_USERS_QUANTITY_REQUEST:
        return {
            ...state,
            [action.usersQuantity]: {
                ...state[action.usersQuantity],
            },
        };

    case GET_USERS_QUANTITY_SUCCESS:
        return {
            [action.usersQuantity]: {
                ...state[action.usersQuantity],
                usersQuantity: action.usersQuantity,
            },
        };

    case GET_USERS_QUANTITY_FAILURE:
        return {
            [action.usersQuantity]: {
                ...state[action.usersQuantity],
                error: action.error,
            },
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/reducers/get_users_quantity.reducers.js